import React from 'react';
import Link from 'next/link';

const footerLinks = [
  { href: '/#inicio', label: 'Início' },
  { href: '/#servicos', label: 'Serviços' },
  { href: '/#sobre', label: 'Sobre Nós' },
  { href: '/#espaco', label: 'O Espaço' },
  { href: '/#cuidados', label: 'Cuidados' },
  { href: '/#faq', label: 'FAQ' },
  { href: '/#contacto', label: 'Contacto' },
];

export default function SiteFooter() {
  const whatsappUrl = 'https://wa.me/258874639388';

  return (
    <footer className="bg-dark-brown text-white/80">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-5">
              <p className="font-serif text-2xl font-light tracking-[0.15em] text-white">MÃOS MÁGICAS</p>
              <p className="font-sans text-[10px] tracking-[0.35em] text-burnt-rose font-medium uppercase">BELEZA · MAPUTO</p>
            </div>
            <p className="text-sm text-white/50 leading-relaxed mb-6 max-w-xs">
              Estúdio de beleza feminino especializado em depilação a cera. Cuidado, privacidade e profissionalismo em Maputo.
            </p>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-burnt-rose transition-colors"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" className="text-burnt-rose">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              +258 87 463 9388
            </a>
          </div>

          {/* Links */}
          <div>
            <p className="text-xs tracking-[0.2em] uppercase font-medium text-white/40 mb-5">Navegação</p>
            <ul className="space-y-3">
              {footerLinks?.map(link => (
                <li key={link?.href}>
                  <Link
                    href={link?.href}
                    className="text-sm text-white/60 hover:text-burnt-rose transition-colors duration-200"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div>
            <p className="text-xs tracking-[0.2em] uppercase font-medium text-white/40 mb-5">Marcar Sessão</p>
            <p className="text-sm text-white/50 leading-relaxed mb-6">
              Agende online a qualquer hora ou fale connosco diretamente pelo WhatsApp.
            </p>
            <Link
              href="/agendar"
              className="inline-flex items-center justify-center px-7 py-3.5 bg-burnt-rose text-white rounded-full text-xs tracking-[0.12em] uppercase font-semibold hover:bg-berry transition-colors duration-300"
            >
              Agendar Sessão
            </Link>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/30">
            © Mãos Mágicas. Todos os direitos reservados.
          </p>
          <p className="text-xs text-white/20">
            Maputo, Moçambique
          </p>
        </div>
      </div>
    </footer>
  );
}
